<template>
  <page>
    <page-header-new :title="$t('CampaignsPage_Title_Approve')" />
    <page-content>
      <slot name="list">
        <campaigns-list status="draft" />
      </slot>
    </page-content>
  </page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import CampaignsList from '@/modules/campaigns/components/CampaignsList'
import Page from '@/common/components/page/Page'
import PageContent from '@/common/components/page/PageContent'
export default {
  name: 'ApproveCampaignsPage',
  components: { PageContent, Page, CampaignsList, PageHeaderNew }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/ApproveCampaignsPage.vue